{
  "meta": {
    "title": "GrowMe",
    "description": "GrowMe — a garden of real relationships.",
    "loginTitle": "Sign in · GrowMe",
    "tilesTitle": "GrowMe — Letter series"
  },
  "brand": {
    "name": "GrowMe",
    "tagline": "A garden of real relationships"
  },
  "auth": {
    "loginTitle": "Welcome back",
    "loginLede": "Sign in to tend your garden.",
    "signupTitle": "Create your garden",
    "signupLede": "Start with an email and a password. We’ll send a short verification link.",
    "forgotTitle": "Forgot password",
    "forgotLede": "Enter your email and we’ll send a reset link if an account exists.",
    "resetTitle": "Set a new password",
    "resetLede": "Choose a new password for your GrowMe account.",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "displayNameLabel": "Name",
    "displayNameOptional": "(optional)",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "At least 8 characters",
    "displayNamePlaceholder": "What should we call you?",
    "signIn": "Sign in",
    "createAccount": "Create account",
    "sendResetLink": "Send reset link",
    "savePassword": "Save password",
    "sending": "Sending…",
    "signingIn": "Signing in…",
    "creating": "Creating…",
    "saving": "Saving…",
    "forgotLink": "Forgot password?",
    "backToSignIn": "Back to sign in",
    "needAccount": "New here? ",
    "haveAccount": "Already have an account? ",
    "createAccountLink": "Create an account",
    "signInLink": "Sign in",
    "resendVerification": "Resend verification email",
    "verifiedSuccess": "Email verified — you can sign in now.",
    "verifiedFailed": "That verification link is invalid or expired.",
    "resetInvalid": "That reset link is invalid or expired.",
    "resetSent": "If an account exists for that email, a reset message was sent.",
    "signupSuccess": "Check your inbox to verify your email, then sign in.",
    "passwordResetSuccess": "Password updated — you can sign in now.",
    "checkEmail": "Check your email",
    "errorGeneric": "Something went wrong. Please try again."
  },
  "nav": {
    "garden": "Garden",
    "moments": "Moments",
    "places": "Places",
    "people": "People",
    "main": "Main",
    "signOut": "Sign out",
    "exitGuest": "Exit guest"
  },
  "landing": {
    "lede": "GrowMe turns real-life meetings into a living garden — so the people who matter don’t quietly fade.",
    "point1": "Plant friends and family as tiles in your garden.",
    "point2": "Log moments when you meet — plants grow when you stay in touch.",
    "point3": "See at a glance who you’ve seen this week, and who needs a little care.",
    "createAccount": "Create account",
    "tryGuest": "Try as guest",
    "guestNote": "Guest mode stores everything only in this browser’s local storage — nothing is synced to a server. Create an account when you want to keep your garden safely.",
    "haveAccount": "Already have an account?",
    "signIn": "Sign in"
  },
  "garden": {
    "title": "Your garden",
    "hintEmpty": "Tap empty land to plant someone · long-press works too",
    "hintFilled": "Tap a person · tap empty land to plant someone",
    "loadError": "Could not load garden",
    "errorTitle": "Something went wrong"
  },
  "person": {
    "timesMet": "Times met",
    "sinceLast": "Since last",
    "firstMet": "First met",
    "noMomentsTitle": "No moments yet",
    "noMomentsText": "Log a real meeting and this tile will begin to grow.",
    "edit": "Edit"
  },
  "moments": {
    "title": "Moments",
    "emptyTitle": "No moments yet",
    "emptyText": "When you meet someone in real life, log what mattered.",
    "log": "Log a moment"
  },
  "places": {
    "title": "Places",
    "emptyTitle": "Nowhere yet",
    "emptyText": "Add a place when you log a moment — cafés, parks, kitchen tables.",
    "momentCount": "{count} moment",
    "momentCountPlural": "{count} moments"
  },
  "people": {
    "title": "People",
    "searchPlaceholder": "Search by name",
    "emptyTitle": "No people yet",
    "emptyText": "Add someone you want to keep tending.",
    "add": "Add a person"
  },
  "stages": {
    "week": "blooming",
    "month": "leafy",
    "quarter": "sprouting",
    "year": "resting",
    "older": "fallow"
  },
  "addPerson": {
    "title": "Add a person",
    "editTitle": "Edit person",
    "nameLabel": "Name",
    "namePlaceholder": "Who are they?",
    "nameRequired": "Please enter a name",
    "phoneLabel": "Phone",
    "optional": "(optional)",
    "phonePlaceholder": "+49 …",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "error": "Could not save",
    "delete": "Delete person",
    "deleting": "Deleting…",
    "deleteConfirm": "Delete {name}? They’ll be removed from moments, but the moments and places stay.",
    "deleteError": "Could not delete"
  },
  "logMoment": {
    "title": "Log a moment",
    "editTitle": "Edit moment",
    "peopleLabel": "People",
    "dateLabel": "Date",
    "noteLabel": "What mattered",
    "notePlaceholder": "A short note about this meeting",
    "placeLabel": "Place",
    "placePlaceholder": "Café, park — or both, separated by commas",
    "cancel": "Cancel",
    "save": "Save",
    "saving": "Saving…",
    "error": "Could not save"
  },
  "common": {
    "loading": "Loading…",
    "back": "Back"
  }
}
